import React, { useState } from 'react'
import { ReviewEl } from '../elements'
import Avatar from '../../../../../../../../../../../../Components/Avatar'
import Rating from '../../../../../../../../../../../../Components/Rating/Rating'
import ReviewStore from '../store/ReviewStore'
import Input from '../../../../../../../../../../../../Components/Input/Input'
import Button from '../../../../../../../../../../../../Components/Buttons/Button'

function AddReview() {
  const {
    courseId,
    user: {
      profile: { name },
      ...user
    },
    teacher: { id: teacherId },
    addReview,
  } = ReviewStore.useContainer()
  const [rating, setRating] = useState(0)
  const [review, setReview] = useState('')
  return (
    <ReviewEl>
      <div className='basicInfo'>
        <div className='userInfo'>
          <Avatar name={name} image={user?.picture} size={3} />
          <p>{name}</p>
        </div>
        <Rating value={rating} onChange={(val) => setRating(val)} inputMode />
      </div>
      <Input
        placeholder='Review'
        defaultValue={review}
        type={'textarea'}
        onChange={(e) => setReview(e.target.value)}
      />
      <Button
        onClick={() => {
          addReview(teacherId, courseId, 'COURSE', 'BATCH', review, rating)
        }}
        name={'Submit'}
      />
    </ReviewEl>
  )
}

export default AddReview
